<div class="requiredStamp__badge__container">
  <mat-icon 
    matBadge="{{(requiredStampTotal$| async).toString()}}"
    matBadgeHidden="{{(requiredStampTotal$| async) === 0}}"
    matBadgeSize="small"
    data-testid="stamp-text"
    class="requiredStamp__badge__icon"
    matBadgePosition="above right"
    matTooltip="Notary Stamps"
    matTooltipClass="scorecard-icon-tooltip"
  >
  </mat-icon>
  <span class="cdk-visually-hidden">Count of required Stamp(s) remaining to place</span>
</div>
